var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 15,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4553 4.82604L2.13121 16.1501C1.89795 16.3834 1.60106 16.5 1.24056 16.5C0.880053 16.5 0.583168 16.3834 0.349901 16.1501C0.116634 15.9168 0 15.6199 0 15.2594C0 14.8989 0.116634 14.6021 0.349901 14.3688L11.674 3.04473H2.00398C1.64347 3.04473 1.34129 2.9228 1.09742 2.67893C0.853545 2.43506 0.73161 2.13287 0.73161 1.77237C0.73161 1.41186 0.853545 1.10968 1.09742 0.865805C1.34129 0.621935 1.64347 0.5 2.00398 0.5H14.7276C15.0881 0.5 15.3903 0.621935 15.6342 0.865805C15.8781 1.10968 16 1.41186 16 1.77237V14.496C16 14.8565 15.8781 15.1587 15.6342 15.4026C15.3903 15.6465 15.0881 15.7684 14.7276 15.7684C14.3671 15.7684 14.0649 15.6465 13.8211 15.4026C13.5772 15.1587 13.4553 14.8565 13.4553 14.496V4.82604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.037410a8a73b6b1c37ad6f53d722cc21.svg";
export { ForwardRef as ReactComponent };